import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordScreen } from '@/components/auth/forgot-password-screen'

export const Route = createFileRoute('/forgot-password')({
  head: () => ({ meta: [{ title: 'Reset password — Constellation QR' }] }),
  component: ForgotPasswordScreen,
})
